import React from 'react';
import { ChevronRight } from 'lucide-react';

export const ButtonPanel = ({ onClick, title, subtitle, rightIcon, leftIcon, color = 'bg-blue-500', className = '' }) => {
  return (
    <button
      onClick={onClick}
      className={`w-full p-4 bg-white rounded-lg shadow-md hover:shadow-lg transition flex items-center justify-between border-l-4 ${color} ${className}`}
    >
      <div className="flex items-center gap-3 flex-1 text-left">
        {leftIcon && (
          <div className="text-xl">
            {leftIcon}
          </div>
        )}
        <div className="min-w-0">
          <p className="font-semibold text-gray-900 truncate">{title}</p>
          {subtitle && (
            <p className="text-sm text-gray-500 truncate">{subtitle}</p>
          )}
        </div>
      </div>
      {rightIcon ? (
        <div className="text-gray-400 flex-shrink-0 ml-2">
          {rightIcon}
        </div>
      ) : (
        <ChevronRight className="text-gray-400 flex-shrink-0 ml-2" size={20} />
      )}
    </button>
  );
};
